import { render, staticRenderFns } from "./ConsultarIncidente.vue?vue&type=template&id=615f81e0"
import script from "./ConsultarIncidente.vue?vue&type=script&lang=js"
export * from "./ConsultarIncidente.vue?vue&type=script&lang=js"
import style0 from "./ConsultarIncidente.vue?vue&type=style&index=0&id=615f81e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports